import { supabase } from '@/lib/supabase'

export type RoleFiboTargetsPolicy = {
  role: string
  fibo_targets_enabled: boolean
}

export type PlanFiboTargetsPolicy = {
  plan_id: string
  fibo_targets_enabled: boolean
}

export async function fetchRoleFiboTargetsPolicies(): Promise<RoleFiboTargetsPolicy[]> {
  const { data, error } = await supabase
    .from('role_fibo_targets_policies')
    .select('role,fibo_targets_enabled')
    .order('role', { ascending: true })

  if (error) throw error
  return (data || []) as RoleFiboTargetsPolicy[]
}

export async function upsertRoleFiboTargetsPolicy(role: string, enabled: boolean): Promise<void> {
  const { error } = await supabase
    .from('role_fibo_targets_policies')
    .upsert({ role, fibo_targets_enabled: enabled }, { onConflict: 'role' })

  if (error) throw error
}

export async function fetchPlanFiboTargetsPolicies(): Promise<PlanFiboTargetsPolicy[]> {
  const { data, error } = await supabase
    .from('plan_fibo_targets_policies')
    .select('plan_id,fibo_targets_enabled')
    .order('plan_id', { ascending: true })

  if (error) throw error
  return (data || []) as PlanFiboTargetsPolicy[]
}

export async function upsertPlanFiboTargetsPolicy(planId: string, enabled: boolean): Promise<void> {
  const { error } = await supabase
    .from('plan_fibo_targets_policies')
    .upsert({ plan_id: planId, fibo_targets_enabled: enabled }, { onConflict: 'plan_id' })

  if (error) throw error
}

